import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import PropTypes from "prop-types"
import "./requestPopUp.css";
import strings from "../../utils/property-file/requestPopUp.json";
import moment from "moment";
import {
  extractTime,
  convertUtcToIst,
} from "../../utils/commonFunction/timeConvertor";
import api from "../../services/api";
import { toast } from "react-toastify";
import SpinnerButtonMedium from "../button/SpinnerButtonMedium";

function RequestPopUp(props) {
   const requestDetails= props.requestData;
   const [previewingRequestDecline , setPreviewingRequestDecline] = useState(false);
   const [previewingRequestApprove , setPreviewingRequestApprove] = useState(false);
   
  const actionRequest = async (status) =>{
    try{
      const body={
        requestId : requestDetails._id,
        action : status
      }
      const response = await api.previewAttendanceRequest(body);
      if(response && response.data)
      {
        const data = JSON.parse(response.data);
        if(response.success)
        {
          toast.success(data.body , {toastId : "error6"})
          props.onHide();
        }
        else{
          toast.error(data.body , {toastId : "error14"})
        }
      }
      props.fetchRequest();
      setPreviewingRequestApprove(false);
      setPreviewingRequestDecline(false);
    }
    catch(error){
      setPreviewingRequestApprove(false);
      setPreviewingRequestDecline(false);
      toast.error(strings.somethingWentWrongLabel , {toastId : "error14"})
    }
  }


    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="request-pop-up" 
      >
<div className="main-header-container-request-pop-up">
    <div className="attendance-pop-up-name">
            {strings.requestDetails}
    </div>
    <div className="close-request-icon"><i className="ri-close-line" onClick={props.onHide}></i></div>
    </div>
    <div className="main-container-attendance-request-pop-up">
      <div className="request-attendance-pop-up-sub-container">
        <div className="attendance-request-info">
        <div className="attendance-requester-name">
            <span className="heading-name-attendance-request">{strings.empNameLabel}</span> : {requestDetails.userName.name}
        </div>
        <div className="attendance-requester-emp-id">
            <span className="heading-name-attendance-request">{strings.empIdLabel}</span> : {requestDetails.userName.empId}
        </div>
        <div className="attendance-request-date">
          <span className="heading-name-attendance-request">{strings.dateOfAttendance}</span> : {moment.utc(requestDetails.checkoutTime).format("DD-MM-YYYY")}
        </div>
        <div className="attendance-request-check-in">
            <span className="heading-name-attendance-request">{strings.checkInLabel}</span> : {extractTime(convertUtcToIst(requestDetails.checkinTime))}
        </div>
        <div className="attendance-request-requested-checkout">
            <span className="heading-name-attendance-request">{strings.requestedCheckOut} </span>: {extractTime(convertUtcToIst(requestDetails.checkoutTime))}
        </div>
        <div></div>
        <div className="heading-requested-on">{strings.requestedOnLabel}</div>
        <div></div>
        <div className="attendance-request-time">
        <span className="heading-name-attendance-request">{strings.dateLabel}</span> : {moment(requestDetails.createdDate).format("DD-MM-YYYY")}
        </div>
        <div className="attendance-request-time">
        <span className="heading-name-attendance-request">{strings.timeLabel}</span> : {moment(requestDetails.createdDate).format("HH:mm")}
        </div>
        </div>
        <div className="attendance-request-reason">
            <span className="heading-name-attendance-request">{strings.reasonLabel} </span>: {requestDetails.reason}
        </div>
        <div className="request-attendance-button">
            <button className="request-attendance-decline" disabled={previewingRequestDecline || previewingRequestApprove} onClick={(()=>{
              setPreviewingRequestDecline(true)
              actionRequest(strings.deny);
            })}>
                {previewingRequestDecline ? <SpinnerButtonMedium/> :   strings.declineLabel}
            </button>
            <button className="request-attendance-approve" disabled={previewingRequestDecline || previewingRequestApprove}  onClick={(()=>{
              setPreviewingRequestApprove(true)
              actionRequest(strings.approved);
            })}>
            {previewingRequestApprove ? <SpinnerButtonMedium/> :   strings.approveLabel}
                
            </button>
        </div>
        </div>
    </div>
  </Modal>
    );
  }

  RequestPopUp.propTypes = {
    requestData: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      userName: PropTypes.shape({
        name: PropTypes.string.isRequired,
        empId: PropTypes.string.isRequired
      }).isRequired,
      checkoutTime: PropTypes.string.isRequired,
      checkinTime: PropTypes.string.isRequired,
      createdDate: PropTypes.string.isRequired,
      reason: PropTypes.string.isRequired
    }).isRequired,
    onHide: PropTypes.func.isRequired,
    fetchRequest: PropTypes.func.isRequired
};

export default RequestPopUp;